import { matchPath } from 'react-router-dom';

// Título de la pestaña del navegador por pantalla. Los patrones son los de
// React Router (sin el prefijo `/dashboard`, que se resuelve aparte).
// El orden importa: gana la primera coincidencia.
const TITULOS = [
  ['/', 'Acceso'],
  ['/clasificacion', 'Clasificación'],
  ['/jugadores', 'Jugadores'],
  ['/equipos', 'Equipos'],
  ['/jornadas/:id', 'Detalle de jornada'],
  ['/jornadas', 'Jornadas'],
  ['/calendario', 'Calendario'],
  ['/competicion', 'Pistas'],
  ['/competicion-2', 'Pistas'],
  ['/mi-area-personal', 'Mi área personal'],
  ['/styling', 'Guía de estilo'],
  ['/actas', 'Actas'],
  ['/form', 'Resultados'],
  ['/temporadas/:id', 'Temporada'],
  ['/temporadas', 'Temporadas'],
  ['/pantallas', 'Pantallas'],
  ['/alta-usuario', 'Alta de usuarios'],
];

const SUFIJO = 'FMDS';
const TITULO_POR_DEFECTO = 'Liga de Bádminton';

const buscar = (ruta) => TITULOS.find(([patron]) => matchPath({ path: patron, end: true }, ruta))?.[1];

// '/calendario' -> 'Calendario FMDS'
// '/dashboard/calendario' -> 'Gestión - Calendario FMDS'
// '/dashboard' -> 'Gestión - Menú FMDS'
export const tituloPantalla = (pathname) => {
  const ruta = pathname.replace(/\/+$/, '') || '/';
  if (ruta === '/dashboard') return `Gestión - Menú ${SUFIJO}`;
  if (ruta.startsWith('/dashboard/')) {
    const nombre = buscar(ruta.slice('/dashboard'.length));
    return nombre ? `Gestión - ${nombre} ${SUFIJO}` : TITULO_POR_DEFECTO;
  }
  const nombre = buscar(ruta);
  return nombre ? `${nombre} ${SUFIJO}` : TITULO_POR_DEFECTO;
};
